import { LoadingStates } from '@pb/utils'

import HeaderStateType from './types'

const initialState: Partial<HeaderStateType> = {
  headerStatus: LoadingStates.NotLoaded,
}

export default initialState
